import React from "react";
import { useNavigate } from "react-router-dom";
import Profile from "../../pages/common/Profile/Profile";

const RoleAwareProfile = ({ role }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(`/${role}/dashboard`);
  };

  const handleSaveSuccess = () => {
    navigate(`/${role}/dashboard`);
  };

  return (
    <Profile
      role={role}
      onBack={handleBack}
      onSaveSuccess={handleSaveSuccess}
    />
  );
};

export default RoleAwareProfile;
